module.exports = __webpack_public_path__ + "static/media/survey-bg-mobile.1d95ce07.png";